import { render, staticRenderFns } from "./PanelColumnLayout.vue?vue&type=template&id=63240fb3"
import script from "./PanelColumnLayout.vue?vue&type=script&lang=js"
export * from "./PanelColumnLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports